<template>
  <div>
    <el-button round size="mini" :style="{color: 'green'}" @click="toggleDialog">CHK</el-button>
    <el-dialog :title="name" :visible.sync="dialogVisible">
      <div slot="title" class="title-container">
        <span>{{name}}</span>
        <div class="prices-container">
          <span>Standard:&nbsp;{{prices.standard}}</span>
          <span>&nbsp;&nbsp;|&nbsp;&nbsp;</span>
          <span>Month Spcl:&nbsp;{{prices.special}}</span>
          <span>&nbsp;&nbsp;|&nbsp;&nbsp;</span>
          <span>Cls A/COD:&nbsp;{{prices.classA}}</span>
          <span>&nbsp;&nbsp;|&nbsp;&nbsp;</span>
          <span>Cls B/Spcl:&nbsp;{{prices.classB}}</span>
          <span>&nbsp;&nbsp;|&nbsp;&nbsp;</span>
          <span>Ocop/VIP:&nbsp;{{prices.ocop}}</span>
        </div>
      </div>

      <el-table
        :data="orders"
        :row-style="{height:'40px'}"
        stripe
        border
        size="small"
        :header-cell-style="{background:'#D7D7D7',color:'#000',height:'30px'}"
      >
        <el-table-column width="100" property="no" label="INV Num."></el-table-column>
        <el-table-column width="100" property="date" label="INV Date"></el-table-column>
        <el-table-column width="100" property="dueDate" label="Due Date"></el-table-column>
        <el-table-column width="130" property="reference" label="Reference"></el-table-column>
        <el-table-column property="csrName" label="CSR Name"></el-table-column>
        <el-table-column width="60" property="qty" label="QTY." align="right"></el-table-column>
        <el-table-column width="80" property="unitPrice" label="Unit Price" align="right"></el-table-column>
        <el-table-column width="75" property="amount" label="Amount" align="right"></el-table-column>
        <el-table-column width="100" label="Detail" align="center">
          <template v-slot="scope">
            <el-button size="mini" :style="{color: 'green'}" @click="handleView(scope.row)">View</el-button>
          </template>
        </el-table-column>
        <div slot="empty"><span class="popover-table-empty-text">No Data</span></div>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import { productHistory } from '../api'
import { mapGetters } from 'vuex'
export default {
  name: 'BillHistory',
  data () {
    return {
      dialogVisible: false,
      name: '',
      prices: {
        standard: '',
        special: '',
        classA: '',
        classB: '',
        ocop: ''
      },
      orders: []
    }
  },
  computed: {
    ...mapGetters({
      qCsrId: 'search/csrId',
      csrId: 'edit/csrId',
      getRouteNameFromOrderType: 'getRouteNameFromOrderType'
    })
  },
  props: {
    row: {
      type: Object,
      required: true
    }
  },
  methods: {
    async toggleDialog () {
      this.dialogVisible = !this.dialogVisible
      let data
      if (this.row.product) {
        // it came from the inv or cn order details
        data = await productHistory(this.row.product.id, this.csrId)
      } else {
        // came from quotings
        data = await productHistory(this.row.id, this.qCsrId)
      }
      this.name = data.product.name
      this.prices.standard = data.product.standard
      this.prices.special = data.product.special
      this.prices.classA = data.product.classA
      this.prices.classB = data.product.classB
      this.prices.ocop = data.product.ocop
      this.orders = data.data
    },
    handleView (row) {
      const routeName = this.getRouteNameFromOrderType(row.type)
      const routeData = this.$router.resolve({ name: 'OrderDetail', params: { routeName: routeName, id: row.id } })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.title-container {
  color: #000;
  line-height: 48px;
  padding: 0 60px 0 20px;
  font-size: 13px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
}
</style>
